import { render } from "./FilterSidebar.vue?vue&type=template&id=2512add8&scoped=true"
import script from "./FilterSidebar.vue?vue&type=script&lang=js"
export * from "./FilterSidebar.vue?vue&type=script&lang=js"

import "./FilterSidebar.vue?vue&type=style&index=0&id=2512add8&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2512add8"]])

export default __exports__